/** Системная подпись для отсутствующего display-значения. */
export const EMPTY_DISPLAY_VALUE = "<Пусто>";

/**
 * Возвращает display-значение или системную подпись для пустого текста.
 * @param value исходная строка для отображения
 */
export function formatEmptyDisplayValue(value: string | null | undefined): string {
    if (value == null || value.trim() === "") {
        return EMPTY_DISPLAY_VALUE;
    }

    return value;
}
